import React, { useState, useEffect } from "react";
import Logo from "../assets/boj-images/dark_boj.png";
import backgroundImage from "../assets/boj-images/login_banner.jpeg";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import { message } from "antd";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { Spinner } from "react-bootstrap";
import Footer from "../components/superAdmin/footer/Footer";
import useBranding from "../hooks/useBranding";
import { portalAuth } from "../utils/portalAuth";

function CommonLogin({ header, afterLogin, loginFailed, prem_name }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const { logoUrl, backgroundUrl } = useBranding();

  const navigate = useNavigate();

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      handleChange();
    }
  };
  useEffect(() => {
    if (portalAuth.getActiveToken()) {
      axios
        .get(
          `${
            process.env.REACT_APP_API_END_POINT
          }/check-authenticity/${portalAuth.getActiveToken()}`
        )
        .then((resData) => {
          if (
            resData.data.status &&
            resData.data.permission_names.includes(prem_name)
          ) {
            navigate(afterLogin);
          } else {
            navigate(loginFailed);
          }
        });
    }
  }, []);

  const handleChange = () => {
    setIsLoading(true);
    if (!email) {
      message.error("Enter username or email");
      setIsLoading(false);
      return;
    }
    if (!password) {
      message.error("Enter password");
      setIsLoading(false);
      return;
    } else {
      axios
        .post(`${process.env.REACT_APP_API_END_POINT}/login`, {
          email,
          password,
        })
        .then((response) => {
          const portal = portalAuth.getActivePortal();
          portalAuth.setAuth(
            portal,
            response.data.token,
            response.data.category.permissions,
            response.data.category._id
          );
          setIsLoading(false);
        })
        .catch((error) => {
          setIsLoading(false);
          console.log(error);
        })
        .finally(() => {
          let data = portalAuth.getActivePermission();
          data = JSON.parse(data);

          console.log("data", data);
          let nameArray = [];

          axios
            .post(
              `${process.env.REACT_APP_API_END_POINT}/get-permission-name`,
              {
                permission: data,
              }
            )
            .then((res) => {
              // console.log(".data.data", res.data.data);
              nameArray = res.data.data;

              if (nameArray.includes(prem_name)) {
                // console.log("running inside if");

                // Store deletePermission from check-authenticity
                const portal = portalAuth.getActivePortal();
                if (portal === 'superadmin') {
                  const activeToken = portalAuth.getActiveToken();
                  if (activeToken) {
                    axios
                      .get(
                        `${process.env.REACT_APP_API_END_POINT}/check-authenticity/${activeToken}`
                      )
                      .then((authRes) => {
                        localStorage.setItem(
                          'superadmin_delete_permission',
                          authRes.data.deletePermission ? 'true' : 'false'
                        );
                      })
                      .catch((err) => {
                        console.error('Failed to fetch deletePermission', err);
                        localStorage.setItem('superadmin_delete_permission', 'false');
                      });
                  }
                }

                navigate(afterLogin);
              } else {
                message.error("Not Authorised");
              }
            });
        });
    }
  };

  return (
    <>
      <div>
        <div className="container-fluid">
          <div className="row vh-100">
            <div
              className="col-lg-12 col-md-12  d-lg-block p-0 img-col"
              style={{ position: "fixed" }}
            >
              <img
                src={backgroundUrl || backgroundImage}
                alt="Placeholder"
                className="img-fluid vh-100 w-60 top-img"
              /> 
            </div>
            <div className="col-lg-7 col-md-7 d-flex flex-column align-items-center justify-content-center ms-auto p-2">
              <img
                src={logoUrl || Logo}
                alt="logo-img"
                style={{ width: "250px" }}
              />
              <div className="exhibitorlogin w-[250 px]">
                <div className="exhibitorloginbody">
                  <div className="fw-semi-bold fs-3 text-center mb-3">
                    {header}
                  </div>
                  <Form className="my-4">
                    <Form.Control
                      type="username"
                      id="inputUsename"
                      aria-describedby="passwordHelpBlock"
                      placeholder="Username"
                      className="my-4"
                      required
                      onChange={(e) => setEmail(e.target.value)}
                      onKeyDown={handleKeyDown}
                    />

                    <Form.Control
                      type="password"
                      id="inputPassword5"
                      aria-describedby="passwordHelpBlock"
                      placeholder="Password"
                      required
                      onChange={(e) => setPassword(e.target.value)}
                      onKeyDown={handleKeyDown}
                    />

                    <Button className="my-4 btn-block" onClick={handleChange}>
                      {isLoading ? (
                        <Spinner animation="border" size="sm" />
                      ) : (
                        "Login"
                      )}
                    </Button>
                  </Form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default CommonLogin;
